import DataObjectField from '@/utilities/classes/data-object-field';
const buildCommunicationLogDataObject = (vData) => {
  

  var message = "";

  var currDate = new Date();
  
  const fields = [
    new DataObjectField(Number(vData.appid), 10),
    new DataObjectField("Resubmission", 47),
    new DataObjectField(currDate, 51),
    new DataObjectField("Resubmission form answers", 72),
  ];

  if(vData.Landlord.RentalLicenseNumber != null){
    message += "Rental License Number: " + vData.Landlord.RentalLicenseNumber + "\n";
  }
  if(vData.Landlord.ContactInformation.FirstName != null){
    message += "Landlord First Name: " + vData.Landlord.ContactInformation.FirstName + "\n";
  }
  if(vData.Landlord.ContactInformation.LastName != null){
    message += "Landlord Last Name: " + vData.Landlord.ContactInformation.LastName + "\n";
  }
  if(vData.Landlord.ContactInformation.CellPhone != null){
    message += "Landlord Cell Phone: " + vData.Landlord.ContactInformation.CellPhone + "\n";
  }
  if(vData.Landlord.ContactInformation.EmailAddress != null){
    message += "Landlord Email Address: " + vData.Landlord.ContactInformation.EmailAddress + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.FirstName != null){
    message += "Property Management Rep First Name: " + vData.PropertyManagementRepresentative.ContactInformation.FirstName + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.LastName != null){
    message += "Property Management Rep Last Name: " + vData.PropertyManagementRepresentative.ContactInformation.LastName + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.CellPhone != null){
    message += "Property Management Rep Cell Phone: " + vData.PropertyManagementRepresentative.ContactInformation.CellPhone + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.EmailAddress != null){
    message += "Property Management Rep Email Address: " + vData.PropertyManagementRepresentative.ContactInformation.EmailAddress + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepFirstName != null){
    message += "Mediation Rep First Name: " + vData.PropertyManagementRepresentative.ContactInformation.MediationRepFirstName + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepLastName != null){
    message += "Mediation Rep Last Name: " + vData.PropertyManagementRepresentative.ContactInformation.MediationRepLastName + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepPhone != null){
    message += "Mediation Rep Phone: " + vData.PropertyManagementRepresentative.ContactInformation.MediationRepPhone + "\n";
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepEmail != null){
    message += "Mediation Rep Email: " + vData.PropertyManagementRepresentative.ContactInformation.MediationRepEmail + "\n";
  }
  if(vData.Tenant.ContactInformation.FirstName != null){
    message += "Tenant First Name: " + vData.Tenant.ContactInformation.FirstName + "\n";
  }
  if(vData.Tenant.ContactInformation.LastName != null){
    message += "Tenant Last Name: " + vData.Tenant.ContactInformation.LastName + "\n";
  }
  if(vData.Tenant.ContactInformation.CellPhone != null){
    message += "Tenant Cell Phone: " + vData.Tenant.ContactInformation.CellPhone + "\n";
  }
  if(vData.Tenant.ContactInformation.EmailAddress != null){
    message += "Tenant Email Address: " + vData.Tenant.ContactInformation.EmailAddress + "\n";
  }
  if(vData.Tenant.ContactInformation.SecondaryFirstName != null){
    message += "Tenant Secondary First Name: " + vData.Tenant.ContactInformation.SecondaryFirstName + "\n";
  }
  if(vData.Tenant.ContactInformation.SecondaryLastName != null){
    message += "Tenant Secondary Last Name: " + vData.Tenant.ContactInformation.SecondaryLastName + "\n";
  }
  if(vData.Tenant.ContactInformation.SecondaryCellPhone != null){
    message += "Tenant Secondary Cell Phone: " + vData.Tenant.ContactInformation.SecondaryCellPhone + "\n";
  }
  if(vData.Tenant.ContactInformation.SecondaryEmailAddress != null){
    message += "Tenant Secondary Email Address: " + vData.Tenant.ContactInformation.SecondaryEmailAddress + "\n";
  }
  if(vData.Arrears != null){
    message += "Arrears Amount: " + vData.Arrears + "\n";
  }
  if(vData.WithdrawTFA == "Yes"){
    message += "Withdraw TFA: Yes\n";
  }
  if(vData.Tenant.ContactInformation.Address.Street1 != null){
    message += "Tenant Address Street 1: " + vData.Tenant.ContactInformation.Address.Street1 + "\n";
    message += "Tenant Address Street 2: " + vData.Tenant.ContactInformation.Address.Street2 + "\n";
    message += "Tenant Address City: " + vData.Tenant.ContactInformation.Address.City + "\n";
    message += "Tenant Address State: " + vData.Tenant.ContactInformation.Address.State + "\n";
    message += "Tenant Address Zip: " + vData.Tenant.ContactInformation.Address.Zip + "\n";
    message += "Tenant Address Country: " + vData.Tenant.ContactInformation.Address.Country + "\n";
  }
  if(vData.BankInfo.AccountNumber != null){
    message += "Bank Account Number: " + "\n";
  }
  if(vData.BankInfo.RoutingNumber != null){
    message += "Bank Routing Number: " + "\n";
  }
  if(vData.BankInfo.BankName != null){
    message += "Bank Name: " + vData.BankInfo.BankName + "\n";
  }
  if(vData.BankInfo.NameOnBankAccount != null){
    message += "Name on Bank Account: " + vData.BankInfo.NameOnBankAccount + "\n";
  }
  if(vData.W9Info.W9EINNumber != null){
    message += "W9 EIN Number: " + "\n";
  }
  if(vData.W9Info.SSN != null){
    message += "W9 SSN: " + "\n";
  }
  if(vData.PropertyOwnerBusinessName != null){
    message += "Property Owner Business Name: " + vData.PropertyOwnerBusinessName + "\n";
  }
  if(vData.W9Info.Address.Street1 != null){
    message += "W9 Address Street 1: " + vData.W9Info.Address.Street1 + "\n";
    message += "W9 Address Street 2: " + vData.W9Info.Address.Street2 + "\n";
    message += "W9 Address City: " + vData.W9Info.Address.City + "\n";
    message += "W9 Address State: " + vData.W9Info.Address.State + "\n";
    message += "W9 Address Zip: " + vData.W9Info.Address.Zip + "\n";
    message += "W9 Address Country: " + vData.W9Info.Address.Country + "\n";
  }

  fields.push(new DataObjectField(message, 71));


  console.log(fields);
    
  const dataObject = {
    qdbapi: {
      rid: Number(vData.appid),
      udata : "EVICTION_DIVERSION_RESUBMISSION_COMM_LOG",
      field: fields,
    },
  };

  
  return dataObject;
};
export default buildCommunicationLogDataObject;